import React, { Component } from 'react';
import { ButtonReg } from 'atoms/Buttons';
import Breadcrumb from 'molecules/Breadcrumb';
import CompanyFilter from 'molecules/CompanyFilter';
import DataTables from 'organisms/DataTable';
import { actualLoadingAcknowledge, actualLoadingCreate, actualLoadingDelete, actualLoadingUpdate} from 'fixtures/permissions';
import { permissionCheck } from 'helpers/permissionCheckHelper';
import { toggleIsLoading } from 'Redux/actions/ViewStateActions';
import { setLocalSettingsTableData } from 'Redux/actions/SettingsTableActions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FilterCol, FilterRow, PageWrapper, RoundedWrapper, StyledDatePicker, TableWrapper } from './styles';
import lo from 'lodash';
import { actionFormatter3 } from 'components/molecules/TableFormatters/actionFormatterNav';

import { Label } from 'components/atoms/Texts/TxtLabel';
import FormSelect from 'components/atoms/Inputs/FormSelect';
import IconPng from 'components/atoms/IconPng/index';
import { withRouter } from 'react-router';
import { withTheme } from 'styled-components';
import { getAllList, postNewData } from 'services/cmsService';
import { BARGE_LOADING, CHECKLIST, BARGE_LOADINGS_FINALIZE } from 'fixtures/api';
import moment from 'moment';

const ic_eye = require('App/assets/images/ic_eye.png')
const defaultFilter = {
  site: '-',
  loadingDate: new Date(new Date().setDate(new Date().getDate()-1)), // default yesterday
  shipmentType: '-',
}
const shipmentTypes = [{name: 'Trans Shipment'},{name: 'Direct Shipment'}]

export class ActualLoadingList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      navList: [
        'Actual Loading',
        'Actual Loading List'
      ],
      allowCreate: false,
      allowDelete: false,
      allowUpdate: false,
      allowAcknowledge: false,
      search: '',
      filter: lo.cloneDeep(defaultFilter),
      currentLoadingDate: null,
      data: [],
    }
  }

  componentDidMount() {
    this.getFilter()
    this.checkPermission()
  }

  componentDidUpdate(prevProps) {
    const { userLogin } = this.props
    if (prevProps.userLogin !== userLogin) {
      this.checkPermission()
    }
  }

  getFilter = () => {
    const { location: { search }} = this.props
    const query = new URLSearchParams(search)
    const filter = {
      site: query.get('site'),
      shipmentType: query.get('shipmentType'),
      loadingDate: query.get('loadingDate'),
      search: query.get('search'),
    }
    const date = filter.loadingDate && moment(filter.loadingDate).format('YYYY-MM-DDT00:00:00Z')
    if ( query.toString() ) {
      this.setState({ filter: lo.omitBy({ ...filter, loadingDate: new Date(date) }, (val) => !val)}, () => {
        this.fetchData()
      })
    } else {
      this.fetchData()
    }
  }

  buildParams = () => {
    const date = this.state.filter.loadingDate && moment(this.state.filter.loadingDate).format('YYYY-MM-DDT00:00:00Z')
    const filter = lo.omitBy({...this.state.filter, loadingDate: date }, (val) => !val || val === '-')
    this.setState({ currentLoadingDate: filter.loadingDate })
    const params = new URLSearchParams(filter).toString()
    return params
  }

  fetchData = async () => {
    this.props.toggleIsLoading(true)
    const params = this.buildParams()
    const data = await getAllList(`${CHECKLIST}?type=${BARGE_LOADING}${params ? `&${params}` : ''}`)
    this.setState({ data }, () => {
      this.props.toggleIsLoading(false)
    })
  }

  // method for checking access permission
  checkPermission() {
    const { userLogin } = this.props
    if (userLogin && userLogin.userDetail) {
      const { userDetail: { permissions } } = userLogin
      this.setState({
        allowCreate: permissionCheck(permissions, actualLoadingCreate),
        allowDelete: permissionCheck(permissions, actualLoadingDelete),
        allowUpdate: permissionCheck(permissions, actualLoadingUpdate),
        allowAcknowledge: permissionCheck(permissions, actualLoadingAcknowledge),
      })
    }
  }

  onEdit(row) {
    const { history: { push } } = this.props
    const search = this.state.search
    const body = lo.omitBy({...this.state.filter, search }, (val) => !val || (val && val === '-'))
    const param = new URLSearchParams(body).toString()
    push(`/dash/actual-loading/edit/${row.id}`, { from: `/dash/actual-loading${param ? `?${param}` : ''}` } )
  }

  // method for adding new actual loading
  addNewActualLoading() {
    const { history: { push } } = this.props
    push('/dash/actual-loading/add')
  }

  onSizePerPageChange = (size) => {
    const { setLocalSettingsTableData, settingsTable } = this.props
    const settings = lo.cloneDeep(settingsTable)
    settings.sizePerPage[this.state.navList[0]] = size
    setLocalSettingsTableData(settings)
  }

  // method to change filter state
  onChangeFilter(val, field) {
    let f = { ...this.state.filter }
    f[field] = val
    this.setState({ filter: f })
  }

  onFilterSubmit() {
    this.fetchData()
  }

  onResetFilter() {
    this.setState({ filter: lo.cloneDeep(defaultFilter)}, () => {
      this.fetchData()
    })
  }

  onSearch = search => this.setState({ search })

  onFinalize = () => {
    const { history: { push } } = this.props
    const loadingDate = this.state.currentLoadingDate && moment(this.state.currentLoadingDate).format()
    const search = this.state.search
    const body = lo.omitBy({...this.state.filter, loadingDate, search }, (val) => !val || (val && val === '-'))
    push({
      pathname: '/dash/actual-loading/finalize',
      search: "?" + new URLSearchParams(body).toString()
    })
  }

  finalize = async () => {
    this.props.toggleIsLoading(true)
    try {
      const search = this.state.search
      const loadingDate = this.state.filter.loadingDate && moment(this.state.filter.loadingDate).format()
      const body = lo.omitBy({...this.state.filter, loadingDate, search }, (val) => !val || (val && val === '-'))
      await postNewData(BARGE_LOADINGS_FINALIZE, body)
      this.fetchData()
    } catch (error) {} finally {
      this.props.toggleIsLoading(false)
    }
  }

  renderFilterRow() {
    const inputConfig = {
      border: this.props.theme.mocaGrey,
      rad: '6px',
      width: 'auto',
      yxPadding: '9px 12px',
      height: '34px',
    }

    const { filter } = this.state
    const { lookups } = this.props

    return (
      <FilterRow>
        <FilterCol>
          <Label lineheight={'14px'} size={'12px'}>
            Site
          </Label>
          <FormSelect
            placeholder={`Select site`}
            onChangeVal={e => this.onChangeFilter(e.target.value, 'site')}
            options={lookups.sites ? lookups.sites : []}
            value={filter.site}
            valField={'name'}
            dispField={'name'}
            arrowSize={'5%'}
            mr={window.innerWidth <= 960 ? '.5rem' : '1.5rem'}
            {...inputConfig}
          />
        </FilterCol>
        <FilterCol>
          <Label lineheight={'14px'} size={'12px'}>
            Loading Date
          </Label>
          <StyledDatePicker
            onChange={loadingDate => this.onChangeFilter( loadingDate, 'loadingDate')}
            value={filter.loadingDate}
          />
        </FilterCol>
        <FilterCol>
          <Label lineheight={'14px'} size={'12px'}>
            Shipment Type
          </Label>
          <FormSelect
            placeholder={`Select shipment type`}
            onChangeVal={e => this.onChangeFilter(e.target.value, 'shipmentType')}
            options={shipmentTypes}
            value={filter.shipmentType}
            valField={'name'}
            dispField={'name'}
            arrowSize={'5%'}
            {...inputConfig}
          />
        </FilterCol>

        <ButtonReg
          btnTxt={
            <IconPng srcIcon={ic_eye} ml={'0'} mb={'3px'} size={'auto'} h={'13'} showPointer={true} />
          }
          rad={'6px'}
          disabled={false}
          onClick={this.onFilterSubmit.bind(this)}
          width={'34px'}
          height={'34px'}
          margin={'0 9px 0 0'}
        />
        <ButtonReg
          btnTxt="Reset"
          rad={'6px'}
          disabled={false}
          onClick={this.onResetFilter.bind(this)}
          height={'34px'}
          width={'50px'}
        />
      </FilterRow>
    )
  }

  render() {
    const { navList, data } = this.state
    const { settingsTable, viewState: { isLoading, isMobileView }, theme } = this.props

    const sizePerPage = settingsTable.sizePerPage[navList[0]]

    const config = [
      {
        dataField: 'action',
        text: 'Action',
        sort: false,
        headerStyle: { width: isMobileView ? 100 : 150 },
        formatter: actionFormatter3,
        formatExtraData: {
          color: this.props.theme.mocaPurple,
          allowEdit: row => {
            return row.status === 'DRAFT'
              ? this.state.allowUpdate
              : this.state.allowUpdate && this.state.allowAcknowledge
          },
          edit: (row) => this.onEdit.bind(this, row),
        },
        isDummyField: true
      },
      {
        dataField: 'createdAt',
        text: 'Requested On',
        headerStyle: { width: isMobileView ? 100 : 150 },
        formatter: (cell, row, rowIndex, formatExtraData) => {
          return <div>{row && row.createdAt ? moment(row.createdAt).format('DD-MMM-YYYY  HH:mm:ss') : '-'}</div>
        },
        sort: true
      },
      {
        dataField: 'status',
        headerStyle: { width: 100 },
        text: 'Status',
        style: (cell, row, rowIndex, colIndex) => {
          if (row && row.status === 'DRAFT') {
            return {
              color: theme.mocaOrange,
              fontWeight: 'bold'
            }
          }
          if (row && row.status === 'FINALIZED') {
            return {
              color: theme.mocaGreen,
              fontWeight: 'bold'
            }
          }
        },
        sort: true
      },
      {
        dataField: 'site',
        headerStyle: { width: 100 },
        text: 'Site',
        sort: true
      },
      {
        dataField: 'noRefReport',
        headerStyle: { width: 100 },
        text: 'Ref Report',
        sort: true
      },
      {
        dataField: 'noServicesTrip',
        headerStyle: { width: 100 },
        text: 'Service Trip',
        sort: true
      },
      {
        dataField: 'tugName',
        headerStyle: { width: isMobileView ? 100 : 150 },
        text: 'Tug Name',
        sort: true
      },
      {
        dataField: 'bargeName',
        headerStyle: { width: isMobileView ? 100 : 150 },
        text: 'Barge Name',
        sort: true
      },
      {
        dataField: 'route',
        headerStyle: { width: 100 },
        text: 'Route',
        sort: true
      },
      {
        dataField: 'loadType',
        headerStyle: { width: isMobileView ? 100 : 150 },
        text: 'Load Type',
        sort: true
      },
      {
        dataField: 'arrivalTime',
        text: 'Arrival',
        headerStyle: { width: isMobileView ? 100 : 150 },
        formatter: (cell, row, rowIndex, formatExtraData) => {
          return <div>{row.arrivalTime ? moment(row.arrivalTime).format('DD-MMM-YYYY  HH:mm') : '-'}</div>
        },
        sort: true
      },
      {
        dataField: 'departure',
        text: 'Depature',
        headerStyle: { width: isMobileView ? 100 : 150 },
        formatter: (cell, row, rowIndex, formatExtraData) => {
          return <div>{row.departure ? moment(row.departure).format('DD-MMM-YYYY  HH:mm') : '-'}</div>
        },
        sort: true
      },
      {
        dataField: 'cargoLoaded',
        text: 'Cargo Loaded',
        headerStyle: { width: 100 },
        formatter: (cell, row, rowIndex, formatExtraData) => {
          const total = row.cargoLoaded.reduce((acc, curr ) => acc = acc + Number(curr.draft), 0 )
          return <div>{total}</div>
        },
        sort: true
      },
    ]

    return (
      <PageWrapper isMobile={isMobileView}>
        <Breadcrumb navList={navList}>
          <CompanyFilter />
        </Breadcrumb>
        {!isLoading &&
        <>
          <RoundedWrapper>
            {this.renderFilterRow()}
          </RoundedWrapper>
          <TableWrapper>
            <DataTables
              leftSlot={
                <>
                  {this.state.allowCreate &&
                  <ButtonReg
                    btnTxt={'Add'}
                    disabled={false}
                    onClick={() => this.addNewActualLoading()}
                    width={'78px'}
                  />}
                  {this.state.allowAcknowledge && data.filter(d => d.status === 'DRAFT').length > 0 &&
                  <ButtonReg
                    btnTxt={'Finalize and Send Daily Barge Report'}
                    onClick={this.onFinalize}
                    width="300px"
                    margin="0 0 0 10px"
                    transparent
                    bordered
                  />}
                </>
              }
              isMobile={isMobileView}
              dataList={data || []}
              columnConfig={config}
              sizePerPage={sizePerPage}
              onSizePerPageChange={this.onSizePerPageChange}
              onSearch={this.onSearch}
            />
          </TableWrapper>
        </>}
      </PageWrapper>
    )
  }
}

const mapStateToProps = (state) => {
  let lookups = {}
  lookups.sites = lo.uniqBy(state.userLogin.userDetail.allowedCompanies.map((d) => ({ name: d.workLocation.name })),
  'name',
  )
  return {
    userLogin: state.userLogin,
    viewState: state.viewState,
    settingsTable: state.settingsTable,
    lookups,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      toggleIsLoading,
      setLocalSettingsTableData,
    },
    dispatch
  )

export default withRouter(
  withTheme(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(ActualLoadingList)
  )
);
